/**
 * 路径开头为
 * report --- 趋势报告
 * df --- 知款
 * douyin --- 抖衣
 * cross-border --- 海外探款
 * meinian --- 美念
 * xhs --- 小红书
 *
 * 其他路径都为知衣
 */

export const getProjectSource = () => {
  if (location.pathname.includes('report')) {
    return '趋势报告'
  }
  if (location.pathname.includes('df')) {
    return '知款'
  }
  if (location.pathname.includes('douyin')) {
    return '抖衣'
  }
  if (location.pathname.includes('cross-border')) {
    return '海外探款'
  }
  if (location.pathname.includes('meinian')) {
    return '美念'
  }
  if (location.pathname.includes('xhs')) {
    return '小红书'
  }
  return '知衣'
}
